import { fetchMatterList } from "../../slice/Matterslice";

// Active Case_Type__c names from the firm's Salesforce org (whg-prod,
// queried 2026-08-24). The Matters page used to hardcode four personal-injury
// types, which hid VA Agency / SSDI / mass-tort cases from the filter.
export const SALESFORCE_CASE_TYPES = [
  "3M Earplugs",
  "AFFF",
  "Bankruptcy",
  "Bard PowerPort",
  "Camp LeJeune",
  "Class Action",
  "Dog Bite",
  "Lexyl Travel Class Action",
  "Medical Malpractice",
  "Medical Malpractice FTCA",
  "Motor Vehicle Accident",
  "Nursing Home Abuse",
  "OSOP",
  "Other",
  "Ozempic Stomach Paralysis",
  "Paraquat Parkinson's",
  "Premises Liability/Slip and Fall",
  "Product Liability",
  "Property Damage",
  "Sexual Assault",
  "SSDI",
  "Suboxone",
  "Uber Sexual Assault",
  "VA Agency",
  "VA CAVC",
  "VA DIC",
  "Workers Compensation",
];

export const CASE_TYPE_DROPDOWN_OPTIONS = [
  ...SALESFORCE_CASE_TYPES.map((name) => ({ value: name, label: name })),
  { value: "All", label: "All" },
];

export const fetchMatterData = async (payload) => {
    const { dispatch, selectedValueCaseType, selectedValue, currentPage, sort, item, pageSize, search, assignedToMe, setIsLoading, handleError } = payload;
    try {
      setIsLoading(true);
      const caseType = selectedValueCaseType === "All" ? null : selectedValueCaseType;
      const status = selectedValue === "All" ? null : selectedValue;
      const response = await dispatch(
        fetchMatterList({
          page: currentPage,
          status: status,
          case_type: caseType,
          sort_order: sort,
          sort_by: item,
          page_size: pageSize,
          search: search,
          assigned_to_me: Boolean(assignedToMe),
        })
      ).unwrap();

      if (response?.status === 200) {
        setIsLoading(false);
      } else {
        handleError("Failed to fetch matters");
      }
    } catch (err) {
      console.error("Failed to fetch matters", err);
      handleError("Failed to fetch matters");
    }
  };

  export const handleSelect = (dispatch, value, setSelectedValue, setCurrentPage) => {
    dispatch(setSelectedValue(value));
    dispatch(setCurrentPage(1));
  };

  export const handleCaseTypeSelect = (dispatch, value, setSelectedValueCaseType, setCurrentPage) => {
    dispatch(setSelectedValueCaseType(value));
    dispatch(setCurrentPage(1));
  };

  export const handleAssignedToMeToggle = (dispatch, value, setAssignedToMe, setCurrentPage) => {
    dispatch(setAssignedToMe(value));
    dispatch(setCurrentPage(1));
  };

  export const handlePageChange = (dispatch, page, setIsLoading, setCurrentPage) => {
    setIsLoading(true);
    dispatch(setCurrentPage(page));
  };

  export const handlePageSizeChange = (dispatch, pageSize, setCurrentPage, setPageSize) => {
    dispatch(setCurrentPage(1));
    dispatch(setPageSize(pageSize));
  };

  